module.exports = __webpack_public_path__ + "assets/img/Gourmet-Basket-eBook-w540.f3c8f0f7.webp";